import {
  HasMetaplansResponseDto,
  SubscriptionListResponseDto,
} from '@tiendanube/common';
import axios from 'App/axios';

export const SubscriptionsService = {
  hasMetaplans: async (): Promise<HasMetaplansResponseDto> => {
    const { data } = await axios.get<HasMetaplansResponseDto>(
      `/v1/stores/subscriptions/hasMetaplans`,
    );
    return data;
  },
  getSubscriptions: async (params?: {
    orderId?: string;
    customerId?: string;
    metaplanId?: string;
  }): Promise<SubscriptionListResponseDto> => {
    const { data } = await axios.get<SubscriptionListResponseDto>(
      `/v1/stores/subscriptions/getSubscriptions`,
      { params },
    );
    return data;
  },
};
